<template>
  <button class="btn"
          :class="btnClass"
          :disabled="disabled || loading">
    <div class="pulse-container"
         v-if="loading">
      <div class="pulse-bubble pulse-bubble-1"></div>
      <div class="pulse-bubble pulse-bubble-2"></div>
      <div class="pulse-bubble pulse-bubble-3"></div>
    </div>
    <slot v-else></slot>
  </button>
</template>

<script>
export default {
  name: 'umfButton',
  computed: {
    btnClass () {
      return [this.radius, { disabled: this.disabled }]
    }
  },
  props: {
    radius: {
      type: String,
      default: ''
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.btn-box {
  border-radius: 0.5rem;
}
.btn {
  display: block;
  width: 100%;
  height: 1rem;
  color: #fff;
  font-size: 0.3rem;
  outline: 0;
  background-color: #4c60bf;
  border-radius: 0.1rem;
  border: none;
  &.disabled {
    background: #999;
  }
  &.left {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
}

@keyframes pulse {
  from {
    opacity: 1;
    transform: scale(1);
  }
  to {
    opacity: 0.25;
    transform: scale(0.75);
  }
}
/* PULSE BUBBLES */

.pulse-container {
  width: 1rem;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.pulse-bubble {
  width: 0.2rem;
  height: 0.2rem;
  border-radius: 50%;
  background-color: #fff;
}

.pulse-bubble-1 {
  animation: pulse 0.4s ease 0s infinite alternate;
}
.pulse-bubble-2 {
  animation: pulse 0.4s ease 0.2s infinite alternate;
}
.pulse-bubble-3 {
  animation: pulse 0.4s ease 0.4s infinite alternate;
}
</style>